export interface MobileSelectedSection {
  sectionId: string
  sectionType: string
  creativeType:
    | 'instagram_post'
    | 'facebook_post'
    | 'linkedin_post'
    | 'tiktok_video'
    | 'x_post'
    | 'youtube_short'
    | 'pinterest_pin'
  label: string
  preview: string
}

export function sectionSupportsCopy(selection: MobileSelectedSection): boolean {
  if (selection.creativeType === 'instagram_post') {
    return selection.sectionType === 'caption' || selection.sectionType === 'hashtags'
  }
  if (selection.creativeType === 'facebook_post') {
    return selection.sectionType === 'message'
  }
  if (selection.creativeType === 'linkedin_post') {
    return selection.sectionType === 'caption' || selection.sectionType === 'hashtags'
  }
  if (selection.creativeType === 'x_post') {
    return selection.sectionType === 'text' || selection.sectionType === 'hashtags'
  }
  if (selection.creativeType === 'pinterest_pin') {
    return selection.sectionType === 'title' || selection.sectionType === 'description'
  }
  return false
}

export function sectionSupportsDownload(selection: MobileSelectedSection): boolean {
  if (
    selection.creativeType === 'instagram_post' ||
    selection.creativeType === 'facebook_post' ||
    selection.creativeType === 'linkedin_post' ||
    selection.creativeType === 'x_post' ||
    selection.creativeType === 'pinterest_pin'
  ) {
    return selection.sectionType === 'image'
  }
  return false
}
